/**
 * Created by rafael on 07.03.17.
 */
import {
  CHANGE_PRINT_STATUS,
  CHANGE_PRINT_FORMAT,
  CHANGE_PRINT_ORIENTATION,
  FINAL_PRINTING_TRIGGERED,
  SET_WINDOW_VIEWPORT,
  SET_PRINT_VIEWPORT,
  CHANGE_PRINT_PDF_STATUS,
} from '../constants';

const initialState = {
  printModalStatus: false,
  printFormat: 'A4',
  printOrientation: 'pionowo',
  finalPrintingTriggered: false,
  windowViewport: { width: null, height: null },
  printViewport: { width: null, height: null },
  printToPdfStatus: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PRINT_STATUS:
      return {
        ...state,
        printModalStatus: !state.printModalStatus,
      };
    case CHANGE_PRINT_FORMAT:
      return {
        ...state,
        printFormat: action.format,
      };
    case CHANGE_PRINT_ORIENTATION:
      return {
        ...state,
        printOrientation: action.orientation,
      };
    case FINAL_PRINTING_TRIGGERED:
      return {
        ...state,
        finalPrintingTriggered: !state.finalPrintingTriggered,
        printModalStatus: false,
      };
    case SET_WINDOW_VIEWPORT:
      return {
        ...state,
        windowViewport: action.windowViewport,
      };
    case SET_PRINT_VIEWPORT:
      return {
        ...state,
        printViewport: action.printViewport,
      };
    case CHANGE_PRINT_PDF_STATUS:
      return {
        ...state,
        printToPdfStatus: action.status !== state.printToPdfStatus ?
          action.status : state.printToPdfStatus,
        printModalStatus: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/reducers/printSettings.js